"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { Spinner } from "@climatepartner/components";
import { useMakeAuth } from "@climatepartner/hooks";
export const AuthenticationContext = createContext(null);
export const useAuthenticationContext = () => {
    const context = useContext(AuthenticationContext);
    if (context === null) {
        throw new Error("Please provide oidc config");
    }
    return context;
};
export function AuthenticationProvider({ oidcConfig, children }) {
    const [state, actions] = useMakeAuth(oidcConfig);
    const { user, isAuthenticated, decodedAccessToken, accessToken, refreshToken } = state;
    if (user === null ||
        !isAuthenticated ||
        decodedAccessToken === null ||
        decodedAccessToken === undefined ||
        accessToken === null ||
        refreshToken === null) {
        return _jsx(Spinner, { isFixed: true });
    }
    return (_jsx(AuthenticationContext.Provider, { value: { oidcConfig, state: { ...state, user, decodedAccessToken, accessToken, refreshToken }, actions }, children: children }));
}
//# sourceMappingURL=AuthenticationContext.js.map